// extracted by mini-css-extract-plugin
module.exports = {"title":"title_title__JwLI_","text":"title_text__2bfK0"};